import { useCallback } from "react";
import { apiFile } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useDecodeBinaryForDeveloper = () => {

  const { handle, setError } = useMessageHandler();
;
  const decode = useCallback(async (file: File): Promise<any | null> => {
    const formData = new FormData();
    formData.append("file", file);

    return await handle(async () => {
      const response = await apiFile.post("/binary/decode", formData);
      const data = response.data;
      return data;
    }).catch((err: Error) => {
      setError("Ungültige Konfigurationsdatei.");
      return null;
    });
  }, [handle]);
  return { decode };
};
